import _ from 'lodash'

export const chartDataWithExtraFieldsForSeller = (chartData) => {
  return _.map(chartData, chart => ({
    ...chart,
    data: _.map(chart.data, item => {
      const totalViewerQuantity = _.flow(
        source => _.map(source, pageView => _.get(pageView, 'viewerQuantity', 0)),
        _.sum
      )(item.source)

      const totalAddCartUserQuantity = _.flow(
        source => _.map(source, pageView => _.get(pageView, 'addCartUserQuantity', 0)),
        _.sum
      )(item.source)

      return {
        ...item,
        totalViewerQuantity,
        totalAddCartUserQuantity
      }
    })
  }))
}
